











import { Vue, Component, Prop } from "vue-property-decorator";
import { toWarekiDatetime } from "#/utility/appDate";
import { Remand } from "#/model/report";

/** 差し戻し情報の見出しと内容 */
@Component
export default class RemandInfo extends Vue {
  /** 差戻し情報 */
  @Prop() private remand!: Remand;

  /** 日時を和暦に変換 */
  private toWarekiDatetime = toWarekiDatetime;
}
